/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Likesonevents2Inputs */

const en_likesonevents2 = /** @type {(inputs: Likesonevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interest in events`)
};

const de_likesonevents2 = /** @type {(inputs: Likesonevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interesse an Events`)
};

/**
* | output |
* | --- |
* | "Interest in events" |
*
* @param {Likesonevents2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const likesonevents2 = /** @type {((inputs?: Likesonevents2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Likesonevents2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_likesonevents2(inputs)
	return de_likesonevents2(inputs)
});
export { likesonevents2 as "likesOnEvents" }